import { ITagResult } from '~src/httpClient/serverApi/types/IResponse';
import { ITagError } from '~src/httpClient/serverApi/types/ITagError';

import { IProcessedViewMonitoringStatusInfo, IRawViewMonitoringStatusInfo } from '../../types/AuthorConfiguredDCRTypes';
import { convertToProcessedMonitoringStatus, convertToProcessedShouldMonitor } from '../../utils/AuthorConfiguredDCRUtils';
import { ITagApiRequestConfig, makeTagApiRequest } from '../TagApiClient';

export interface IUpdateAuthorConfiguredViewParams {
  view_luid: string;
  should_monitor: boolean;
}

export interface IRawUpdateAuthorConfiguredViewResult extends ITagResult {
  // Made it optional for potential error response
  view_monitoring_status?:  IRawViewMonitoringStatusInfo;
}

export interface IProcessedUpdateAuthorConfiguredViewResult {
  viewMonitoringStatusInfo?: IProcessedViewMonitoringStatusInfo;
  errors?: ITagError[];
}

export async function updateAuthorConfiguredViews(params: IUpdateAuthorConfiguredViewParams): Promise<IProcessedUpdateAuthorConfiguredViewResult> {
  const config: ITagApiRequestConfig<IUpdateAuthorConfiguredViewParams, {}> = {
    httpMethod: 'PUT',
    endpoint: 'services/datamonitoring/monitoredViews/authorConfiguredViews',
    requestBody: params
  };

  const { view_monitoring_status, errors } = await makeTagApiRequest<IRawUpdateAuthorConfiguredViewResult, IUpdateAuthorConfiguredViewParams, {}>(config);
  const processedResult: IProcessedUpdateAuthorConfiguredViewResult = {};
  if (view_monitoring_status) {
    processedResult.viewMonitoringStatusInfo = {
      viewLuid: view_monitoring_status.view_luid,
      shouldMonitor: convertToProcessedShouldMonitor(view_monitoring_status.has_should_monitor, view_monitoring_status.should_monitor),
      status: convertToProcessedMonitoringStatus(view_monitoring_status.status)
    };
  }
  if (errors) {
    processedResult.errors = errors;
  }
  return processedResult;
}